setPaymentMethods